import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    isUser: false,
    isAdmin: false,
    isSuperAdmin: false,
}

const statusSlice = createSlice({
    name: "status",
    initialState,
    reducers: {
        setStatus: (state, action) => {
            state.isUser = action.payload.isUser || false;
            state.isAdmin = action.payload.isAdmin || false;
            state.isSuperAdmin = action.payload.isSuperAdmin || false;
        }
    }
});

export default statusSlice.reducer;
export const { setStatus } = statusSlice.actions;
